// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideScrollText as RawLucideScrollText } from "lucide-react";
export const LucideScrollText = /* @__PURE__ */ createIcon(RawLucideScrollText, "LucideScrollText", 2);
